import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=60ddf87e&scoped=true"
import script from "./Examination.vue?vue&type=script&lang=js"
export * from "./Examination.vue?vue&type=script&lang=js"
import style0 from "./Examination.vue?vue&type=style&index=0&id=60ddf87e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddf87e",
  null
  
)

export default component.exports